"use client";

import { BYSTADIUM_SHOP_URL } from "@stadium/helpers/app-routes";
import { StyledLink } from "@stadium/ui/src/components/button/styled-button";

import styles from "./main.module.scss";

const isDev = process.env.NODE_ENV !== "production";
const domain = (process.env.NEXT_PUBLIC_DOMAIN || "").trim();
const homeUrl = isDev
  ? "http://localhost:3000/shops"
  : domain
  ? `https://${domain}/shops`
  : BYSTADIUM_SHOP_URL;

const Custom404Error = () => (
  <div className={styles.NotFoundWrapper}>
    <section className={styles.NotFoundScetion}>
      <div className={styles.NotFoundcontainer}>
        <div className={styles.largeTextNumber}>404</div>
        <div className={styles.pageNotFound}>PAGE NOT FOUND</div>
        <p className={styles.subHeading}>We’re not able to find what you were looking for.</p>
        <StyledLink href={homeUrl} passHref>
          BACK TO HOME
        </StyledLink>
      </div>
    </section>
  </div>
);

export default Custom404Error;
